export default "__VITE_ASSET__050c5b4b__"